import { useContext } from 'react';
import { AuthModalContext } from '../../components/Authentication/AuthModalProvider';

export const useAuthModal = () => useContext(AuthModalContext);
